import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { translateElementRole } from '~/constants/translateElementRole';
import Switcher from '@/Switcher';
import { observer, inject } from 'mobx-react';

@inject("featuresListStore") @observer 
export class ToolTip extends Component{
  constructor(props = { featureId }){
    super(props);
    this.state = {
      elementRole: '', 
      elementContent: ''
    };
    this.onMouseMove = this.onMouseMove.bind(this);
  }
  setElementContent(elementContent){
    this.setState({
        elementContent: elementContent
    });
  }
  setElementRole(elementRole){
    this.setState({
        elementRole: elementRole
    });
  }
  getElementContent(element){
    const ariaLabel = element.getAttribute('aria-label');
    const alt = element.getAttribute('alt');
    const title = element.getAttribute('title');
    return ariaLabel || title || alt || '';
  }
  isValidElement(el){
    return !el.getAttribute('aria-hidden'); 
  }
  getParentElement(el){
    return this.isValidElement(el.parentElement) ? el.parentElement : el;
  }
  onMouseMove(event){
    let element = event.target;
    if (this.$toolTip){
      this.$toolTip.style.left = event.clientX + 'px';
      this.$toolTip.style.top = event.clientY + 'px';
      element = this.isValidElement(element) ? element : this.getParentElement(element);
      this.setElementContent(this.getElementContent(element));
      this.setElementRole(translateElementRole('hebrew', element));
    }
  }
  onToggle(isToggleOn){
    if (isToggleOn) {
      document.addEventListener('mousemove', this.onMouseMove);
    } else {
      document.removeEventListener('mousemove', this.onMouseMove);
    }
  }
  render(){
    let { featureId } = this.props;
    let { elementContent, elementRole } = this.state;
    let { setFeatureOptions, getFeatureById } = this.props.featuresListStore;
    let feature = getFeatureById(featureId);
    let { isToggleOn } = feature.options;
    this.onToggle(isToggleOn);

    return (
      <div>
        { isToggleOn && 
          <div className="billy-tooltip billy-box" ref={(el) => { this.$toolTip = el; }}>
            { elementRole && <b>{ elementRole }</b> }
            { (elementRole && elementContent) && ': ' }
            { elementContent }
          </div> 
        }
        <Switcher changeHandler={ () => setFeatureOptions(featureId, {isToggleOn: !isToggleOn}) } isToggleOn={ isToggleOn } />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Feature/FeatureActions/ToolTip/index.js